import {Component} from "@angular/core";
import {IOccasionService} from "../../../../../domain/occasions/IOccasionService";
import {Occasions} from "../../../../../../../../server/src/base/entities/occasion/Occasions";
import {OccasionsFilters} from "../../../../../domain/occasions/filters/OccasionsFilters";
import {OccasionsSorting} from "../../../../../domain/occasions/sorting/OccasionsSorting";

@Component({
    selector: "occasions-content",
    styleUrls: ['./content.scss'],
    templateUrl: "./content.html"
})
export class OccasionsContentComponent{

    public occasions:Occasions;
    public occasionsFilters:OccasionsFilters;
    public occasionsSorting:OccasionsSorting;

    constructor(private occasionService:IOccasionService){
        this.occasions = new Occasions();
        this.occasionsFilters = new OccasionsFilters(this.occasions);
        this.occasionsSorting = new OccasionsSorting(this.occasionsFilters);
    }

    ngOnInit(){
        this.occasionService.Occasions().then(occasions => {
            this.occasions.SetOccasions(occasions.Value());
            this.occasionsFilters.Update();
        })
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/occasions/content/content.ts